import React, { useEffect} from 'react';
import './sec2.css'
import Cta from '../components/common/cta';
import pic11 from '../assets/pic11.png'
import pic12 from '../assets/pic12.png'
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { supabase } from '../supabase';
import { useState } from 'react';




gsap.registerPlugin(ScrollTrigger);

const Sec2 = () => {

const [event, setevent] = useState(null);


  useEffect(() => {
    const wrapper = document.getElementById('sec2-wrapper');
    const container = document.getElementById('sec2-container');
    const ctx = gsap.context(() => {
      gsap.fromTo(
        container,
        {
          scale: 0.5,
          opacity: 0.4,


        },
        {
          scale: 1,
          opacity: 1,

          ease: 'power2.out',
          scrollTrigger: {
            trigger: wrapper,
            start: 'top center',   
            end: 'center center',  
            scrub: 2,  
            pin: false,
          },
        }
      );
    }, wrapper);

 
    return () => ctx.revert();
  }, []);



  useEffect(() => {
  const getevent = async()=>{
      const res = await supabase.from('exbition_event').select('*').eq('status', 'ongoing')
  .limit(1)
  .single();

  setevent(res.data);
  }
  getevent();
  }, []);
  

const [content, setcontent]= useState([]);
useEffect(() => {
const getcontent = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
setcontent(res.data);
}
getcontent();
}, []);











    return ( 
        <section className='sec2' id='sec2-wrapper'>
                <section className='container-sec2'>
                    <section className='container-info-sec2'  id='sec2-container'>
                            <div className='upper-rectangle'></div>
                            <section className='main-info-sec2'>
                                <article className='left-part-sec2'>
                                    <h1 className='header-sec2'>
                                        {event?.event_name}</h1>
                                    <nav className='navigation-sec2'>
                                           <Cta title= {content?.[33]?.cta} to='/booking'/>
                                    </nav>
                                </article>
                                <article className='right-box-sec2'>
                                    <h1 className='header-sec2'> {event?.start_end_date}</h1>
                                    <article className='container-article-plus-icon'>
                                        <img className='location-icon' src={pic11} alt='location icon'></img>
                                        <h2 className='sentence-sec2'>{event?.location}</h2>
                                    </article>

                                    <article className='container-article-plus-icon'>
                                        <img className='location-icon' src={pic12} alt='time icon'></img>
                                        <h2 className='sentence-sec2'>{event?.time}</h2>
                                    </article>

                                    <p className='parag-sec2'>{event?.description}</p>

                                </article>







                            </section>
                    </section>
                </section>
        </section>
     );
}
 
export default Sec2;